<section>
  <span class="subtitle">{{ 'cookies.required' | translate }}</span>
  <p>{{ 'cookies.requiredDescription' | translate }}</p>

  <opac-accordion-group>
    <opac-accordion
      *ngFor="let cookie of requiredCookies()"
      [title]="cookie.title | translate"
      type="solid"
      size="small"
      iconPosition="start">
      <span slot="end" class="active-label">{{ 'general.always.active' | translate }}</span>

      {{cookie.description | translate}}
    </opac-accordion>
  </opac-accordion-group>
</section>

<section>
  <span class="subtitle">{{ 'cookies.optional' | translate }}</span>
  <p>{{ 'cookies.optionalDescription' | translate }}</p>

  <opac-accordion-group>
    <div class="grid-container" *ngFor="let cookie of optionalCookies(); trackBy: trackCookiesFn">
      <opac-accordion [title]="cookie.title | translate" type="solid" size="small" iconPosition="start">
        {{cookie.description | translate}}
      </opac-accordion>

      <opac-switch
        size="small"
        [checked]="cookie.accepted"
        (change)="setCookieConsent(cookie.id, $event)"
        [disabled]="cookie.required"
        [ariaLabel]="'enable.cookie' | translate: {cookie: cookie.title | translate}">
      </opac-switch>
    </div>
  </opac-accordion-group>
</section>
